import {
  Row,
  Col,
  Card,
  Radio,
  Button,
  Typography,
  Popconfirm,
  Modal,
  Form,
  Input,
  Image,
  Upload,
  message,
} from "antd";

import { useEffect, useState } from "react";
import {
  addCategoryAPI,
  deleteCategoryAPI,
  editCategoryAPI,
  getCategoriesAPI,
} from "../api/category";
import constant from "../config/constant";
import {
  DeleteOutlined,
  EditOutlined,
  InboxOutlined,
  PlusOutlined,
} from "@ant-design/icons";
const { Title } = Typography;

function Category() {
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);
  const [categoryForUpdate, setCategoryForUpdate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMediaRemoved, removeMedia] = useState(false);
  const [mediaURL, setMediaURL] = useState("");
  const _addCategory = async (values) => {
    try {
      let res;
      if (categoryForUpdate) {
        res = await editCategoryAPI(categoryForUpdate, {
          category_name: values?.category_name,
          image_src: mediaURL,
        });
      } else {
        res = await addCategoryAPI({
          category_name: values?.category_name,
          image_src: mediaURL,
        });
      }

      if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        _getCategories();
        setIsModalOpen(false);
        setCategoryForUpdate(null);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const _getCategories = async () => {
    const res = await getCategoriesAPI();
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      setCategories(res?.data);
    }
  };
  const _editCategory = (d) => {
    form.setFieldsValue({
      category_name: d?.category_name,
    });
    setCategoryForUpdate(d?.id);
    setIsModalOpen(true);
  };
  const _deleteCategory = async (id) => {
    const res = await deleteCategoryAPI(id);
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      _getCategories();
    }
  };
  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const removeImageAndMediaURl = () => {
    removeMedia(false);
    setMediaURL("");
  };
  const uploadMedia = {
    name: "image",
    action: constant.API_URL.DEV + "images/upload",
    multiple: false,
    method: "post",
    listType: "picture",
    maxCount: 1,
    data: {
      imgCategory: "category",
    },
    headers: {
      authorization: "Bearer " + localStorage.getItem("token"),
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(
          "🚀 ~ file: Category.js:123 ~ onChange ~ info?.file?.response:",
          info?.file?.response
        );
        // setMediaURL(info?.file?.response?.response?.uploadUrl);
        setMediaURL(info?.file?.response?.data?.image_src);
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  useEffect(() => {
    _getCategories();
  }, []);
  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Main Categories"
              extra={
                <>
                  <Radio.Group onChange={onChange} defaultValue="a">
                    <Radio.Button value="a" onClick={showModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add New Category</span>
                    </Radio.Button>
                  </Radio.Group>
                </>
              }
            >
              <div className="ant-list-box table-responsive m-25">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>
                        <div className="text-center">ID</div>
                      </th>
                      <th>
                        <div className="text-center">Category Name</div>
                      </th>
                      <th>
                        <div className="text-center">Action</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <div className="text-xs text-center">{d?.id}</div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            <Title level={5}>{d?.category_name}</Title>
                            <Image
                              src={d?.image_src}
                              style={{ width: 40, height: 40 }}
                            />
                          </div>
                        </td>

                        <td>
                          <div
                            className="col-action text-right"
                            style={{ justifyContent: "center" }}
                          >
                            <Button
                              type="dashed"
                              className="darkbtn"
                              onClick={() => _editCategory(d)}
                            >
                              <EditOutlined style={{ fontSize: "16px" }} />
                              Edit
                            </Button>
                            <Popconfirm
                              title="Delete this category? "
                              description="Are you sure to delete this category?"
                              okText="Yes"
                              cancelText="No"
                              onConfirm={() => _deleteCategory(d?.id)}
                            >
                              <Button type="dashed" style={{ marginLeft: 10 }}>
                                <DeleteOutlined
                                  className="text-danger"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                />
                                <span className="text-danger">Delete</span>
                              </Button>
                            </Popconfirm>
                            {/* <Button
                              type="dashed"
                              className="darkbtn"
                              style={{ marginLeft: 10 }}
                              onClick={() =>
                                history.push("/sub-category", {
                                  category_id: d?.id,
                                })
                              }
                            >
                              <StepForwardOutlined
                                style={{ fontSize: "16px" }}
                              />
                              Sub Categories
                            </Button> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title="Add Category"
        open={isModalOpen}
        okCancel={false}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addCategory}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Category Name"
            name="category_name"
            rules={[
              {
                required: true,
                message: "Please enter category name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Category Image ">
            <Form.Item
              name="dragger"
              // getValueFromEvent={normfile}
              noStyle
              rules={
                isMediaRemoved
                  ? []
                  : [
                      {
                        required: true,
                        message: "Please upload banner image!",
                      },
                    ]
              }
            >
              {isMediaRemoved ? (
                <div>
                  <Image width={400} src={mediaURL} />
                  <DeleteOutlined
                    style={{
                      fontSize: 30,
                      color: "#cf1322",
                      marginLeft: 20,
                    }}
                    onClick={removeImageAndMediaURl}
                  />
                </div>
              ) : (
                <Upload.Dragger {...uploadMedia}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">
                    Support for a single upload.
                  </p>
                </Upload.Dragger>
              )}
            </Form.Item>
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 20,
              span: 4,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Category;
